// Stable sector -> colour mapping shared by the donut chart and the
// holdings-table sector chips so a sector always reads the same hue across
// the dashboard. Falls back to a deterministic hash colour for any sector
// not in the institutional palette (so a new GICS/FMP label never renders
// an invisible/duplicate slice).

const SECTOR_COLORS: Record<string, string> = {
    Technology: '#0ea5e9',
    'Information Technology': '#0ea5e9',
    Healthcare: '#10b981',
    'Health Care': '#10b981',
    'Financial Services': '#6366f1',
    Financials: '#6366f1',
    'Consumer Cyclical': '#f59e0b',
    'Consumer Discretionary': '#f59e0b',
    'Consumer Defensive': '#84cc16',
    'Consumer Staples': '#84cc16',
    Industrials: '#64748b',
    'Communication Services': '#ec4899',
    Energy: '#ef4444',
    Utilities: '#06b6d4',
    'Real Estate': '#8b5cf6',
    'Basic Materials': '#f97316',
    Materials: '#f97316',
    Unknown: '#cbd5e1',
};

// Deterministic fallback so an unmapped sector is stable across renders.
const FALLBACK_PALETTE = [
    '#0ea5e9',
    '#10b981',
    '#6366f1',
    '#f59e0b',
    '#ec4899',
    '#06b6d4',
    '#8b5cf6',
    '#f97316',
    '#84cc16',
    '#ef4444',
];

export const sectorColor = (sector: string): string => {
    if (SECTOR_COLORS[sector]) return SECTOR_COLORS[sector];
    let hash = 0;
    for (let i = 0; i < sector.length; i += 1) {
        hash = (hash * 31 + sector.charCodeAt(i)) >>> 0;
    }
    return FALLBACK_PALETTE[hash % FALLBACK_PALETTE.length];
};

export default sectorColor;
